import React, { useState, useEffect, useRef } from "react";
import { handleUnauthorized } from "../../utils/apiHelper";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "../child/Loder";

const ViewAcessTypeLayer = () => {
  const [accessTypeData, setAccessTypeData] = useState(null); // State to store user details
  const [loading, setLoading] = useState(true); // State to handle loading
  const { id } = useParams();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  useEffect(() => {
    const fetchUserData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/accessTypeById/${id}`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");

        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }
        const data = await response.json();
        setAccessTypeData(data.result);
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);
  if (loading) return <Loader />;
  return (
    <div className="row gy-4">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="row">
              <div className="col-sm-3">
                <span>
                  <b>Title</b>
                </span>
                <br />
                <p>{accessTypeData?.title || "N/A"}</p>
              </div>

              <div className="col-sm-3">
                <span>
                  <b>Created Date</b>
                </span>
                <br />
                <p>
                  {accessTypeData?.createdAt
                    ? (() => {
                        const date = new Date(accessTypeData.createdAt);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = String(date.getFullYear());
                        return `${day}-${month}-${year}`;
                      })()
                    : "N/A"}
                </p>
              </div>
              <div className="col-sm-3">
                <span>
                  <b>Status</b>
                </span>
                <br />
                <p>{accessTypeData?.status || "N/A"}</p>
              </div>
              <div className="row">
                <strong>
                  <u>Image</u>
                </strong>
              </div>
              <div className="row">
                {accessTypeData.image ? (
                  <div className="col-sm-1">
                    <div className="mb-20">
                      <img
                        src={accessTypeData.image}
                        width="100px"
                        height="100px"
                      />
                    </div>
                  </div>
                ) : (
                  <p>No images available</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAcessTypeLayer;
